import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';

import TopAppBar from './TopAppBar';
import PanelButtons from './PanelButtons';


import { TextField, Typography } from '@material-ui/core';
import {  MessageOutlined, Person,} from '@material-ui/icons';
import { PhoneAndroid } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({

  containerPage: {

  },


  containerFlex: {
    width: "100%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //backgroundColor:"red",
    marginBottom: "5vh"
  },

  containerInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    //backgroundColor: 'blue',
    width: "100%",

    paddingBottom: theme.spacing(3),
    paddingRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),

    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(5),

    fontSize: "1.3rem",
    //textAlign: "center", 
    [theme.breakpoints.up('md')]: {
      width: "40%",
      padding: theme.spacing(1),
    },
  },

  image: {
    width: "120px",
    margin: theme.spacing(0, 0, 1, 0),

    [theme.breakpoints.up('md')]: {
      width: "150px",
      margin: theme.spacing(3, 0, 3, 0),
    },

  },


  rowContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',

    border: "none",
    borderRadius: "0.5rem",
    backgroundColor: theme.palette.background.grey,
    padding: theme.spacing(1, 2, 1, 1),
    marginBottom: "0.8rem"
  },

  inputControl: {
    width: '100%',
    outline: 'none',
    fontSize: '1.2rem',
    border: "none",
    borderRadius: "0.5rem",
    backgroundColor: theme.palette.background.grey,
    padding: theme.spacing(1, 1, 1, 1),
    margin: theme.spacing(0, 0, 0, 1),
  },


  colmnContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',

    border: "none",
    borderRadius: "0.5rem",
    backgroundColor: theme.palette.background.grey,
    //padding:  theme.spacing(1,1,1,1),
    //margin:  theme.spacing(1,1,1,1),

    marginLeft: "0.3rem",
    marginRight: "0.3rem",
    marginTop: "0.3rem",
    marginBottom: "0.2rem",

    paddingLeft: "0.3rem",
    paddingRight: "0.3rem",
    paddingTop: "0.3rem",
    paddingBottom: "0.2rem"


  },


  iconRowMessage: {
    width: '97%',
    display: 'flex',
    justifyContent: 'start',
    marginTop: "0.3rem",
    marginBottom: "0.2rem",
  },

  inputMessage: {
    width: '95%',
    outline: 'none',
    fontSize: '1rem',
    border: "none",
    borderRadius: "0.5rem",
    backgroundColor: theme.palette.background.grey,
    //padding:  theme.spacing(1),
    //margin:  theme.spacing(1,0,1,0),
    paddingLeft: "0.3rem",
    paddingRight: "0.3rem",
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem"

  },



  sizeMessage: {
    width: '97%',
    display: 'flex',
    justifyContent: 'end',
    //backgroundColor: theme.palette.background.pink,
    color: theme.palette.text.muted,
    paddingTop: "0.2rem",
  },


}));


const messageSize = 200;
const phoneMaxSize = 11;
const phoneMinSize = 8;
const nameSize = 20; 


export default function ClientInfoPage(props) {
  
  const classes = useStyles();
  const { store, order, strings, onBack, onNext } = props;
  const requestData = store.clientInfo;
  const currentClient = order.clientInfo; 

  const [message, setMessage] = useState(currentClient.message);
  const [name, setName] = useState( currentClient.name);
  const [phone, setPhone] = useState(currentClient.phone);
  //console.debug("ClientInfoPage:",order)
  const title = order.type === "delivery" ? strings.client_data_title: strings.order_takeaway; 
 
  const handlerOnChangeName = (value) => {
    //console.debug("handlerNext:",value);
  };

  const handlerOnChangePhone = (value) => {
    //console.debug("handlerPhone:",value);

  };

  const handlerBack = () => {
    onBack();
  }

  const handlerNext = () => {
    const clientInfo = {
      ...currentClient,
      name:name, 
      phone:phone, 
      message:message,
    }
    const newOrder = {...order, clientInfo}
    onNext(newOrder); 
  }

  const handlerValidateForm = ()=>{
      const phoneOK = validPhone() || !requestData.phone;
      const nameOK = name || !requestData.name
      return phoneOK && nameOK; 
  }

  const validPhone = ()=>{
    return phone && phone.length>=phoneMinSize
                      && phone.length <= phoneMaxSize; 
  }

  const getIconColorName = ()=>{
      return name ? 'accent': 'icon'; 
  }

  const getIconColorPhone = ()=>{
     return validPhone()? 'accent': 'icon'; 
  }


  return (
    <div className={classes.containerPage}>
      <TopAppBar title={title} />

      <div className={classes.containerFlex}>
        <div className={classes.containerInfo}>
       {/*    <img className={classes.image} src={urlImage} alt={strings.title_payment_options} />
 */}
          { requestData && requestData.name && 
          <div className={classes.rowContent}>
            <Person color={getIconColorName()} fontSize='medium'  ></Person>
            <input
              id="nameId"
              autoComplete="off"
              className={classes.inputControl}
              type="text"
              placeholder={strings.client_name}           
              onChange={(event) => {
                const value = event.target.value; 
                const filter = value.trimStart();
                if(value.length>nameSize) return; 
                setName(filter);
                handlerOnChangeName(filter); 
              }}           
              value={name?name:""}
            />
          </div>
          }

          { requestData && requestData.phone && 
          <div className={classes.rowContent}>
            
            <PhoneAndroid color={getIconColorPhone()} fontSize='medium' />
            <input
              id="phoneId"
              autoComplete="off"
              className={classes.inputControl}
              type="text"           
              pattern="[0-9]*" 
              inputMode="numeric"
              placeholder={strings.client_phone}
              onChange={(event) => {
                const value = event.target.value; 
                if(value.length>phoneMaxSize) return; 
                const filter = value.replace(/[^0-9]/g, ""); 
                setPhone(filter);
                handlerOnChangePhone(filter);
              }}
              value={phone}
            /> 
          </div>
          }

          {requestData && requestData.message && 
          <div className={classes.colmnContent}>
            <div className={classes.iconRowMessage}>
              <MessageOutlined color='icon' fontSize='medium' />
              <Typography ml={1} variant="body1" color='text.muted'>{strings.client_message_label}</Typography>
            </div>


            {
              <div className={classes.inputMessage}     >
                <TextField
                  fullWidth
                  id="messageId"
                  multiline
                  variant="standard"
                  placeholder={strings.client_message_hint}
                  onChange={(event) => {
                    const value = event.target.value; 
                    const filter = value.trimStart();                
                    const result = filter.replace(/(\r\n|\n|\r)/gm, "");
                    setMessage(result);
                  }}
                  value={message}
                  inputProps={{ maxLength: messageSize, }} // need it otherwise it dont block at 200
                  InputProps={{            
                     disableUnderline: true, // <== added this
                     }}
                 
                />
              </div>
            }
            <div className={classes.sizeMessage}>
              <Typography variant="caption">{`${message?message.length:0}/${messageSize}`}</Typography>
            </div>
          </div>
         }





        </div>
        <PanelButtons
          labelCancel={strings.action_back}
          labelNext={strings.action_next}
          onClickCancel={handlerBack}
          onClickNext={handlerNext}
          nextDisabled={!handlerValidateForm()}
        />
      </div>



    </div>
  );
}
